// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */
import { dialogPageTakeoverWidth } from '@atlassian/search-dialog';

export const useIsMobileView = (): boolean => window.innerWidth <= dialogPageTakeoverWidth;
